import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initAutomationsLogic(): void {
    const nodes = document.querySelectorAll('.logic-flow__node');
    if (nodes.length === 0) return;

    // Sequential activation of logic nodes
    const tl = gsap.timeline({
        repeat: -1,
        repeatDelay: 1
    });

    nodes.forEach((node, i) => {
        tl.to(node, { 
            borderColor: '#ff9f1c', 
            boxShadow: '0 0 20px rgba(255, 159, 28, 0.6)', 
            duration: 0.5 
        })
        .to(node, { 
            borderColor: 'rgba(255, 255, 255, 0.06)', 
            boxShadow: 'none', 
            duration: 0.5,
            delay: 0.2
        });
    });
}

export function initGearMotion(): void {
    const gears = document.querySelectorAll('.gear');
    if (gears.length === 0) return;

    gsap.to(gears, {
        rotate: (i, target) => {
            const isReverse = target.classList.contains('gear--md');
            return isReverse ? -360 : 360;
        },
        duration: 10,
        repeat: -1,
        ease: 'none'
    });

    // Parallax gears on scroll
    gsap.to('.gear-system', {
        y: 100,
        scrollTrigger: {
            trigger: '.auto-hero',
            start: 'top top',
            end: 'bottom top',
            scrub: true
        }
    });
}
